import Controller from '../abstracts/Controller';
import 'scss-templates/t-homepage.scss';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'CarouselComponent',
      'EditorialCoverInfiniteComponent',
      'GoogleRecommendationEngineComponent',
      'JournalComponent',
      'LookbookComponent',
      'ManifestoComponent',
      'RecommendationEngineComponent',
      'SocialComponent',
      'StoreEventComponent',
      'WishlistComponent',
    ];
  }
}
